/** Auto-generated from docs/landing-i18n-remaining-source-en.md */
export const landingRemainingEn = {
  aiToolsIndex: {
    seo_content: {
      steps: {
        1: {
          title: 'Input Your Content',
          description: 'Paste your caption, product description, event details, or marketing copy.',
        },
        2: {
          title: 'AI Generates a Structured Layout',
          description:
            'Veeso automatically organizes your content into a balanced, readable, production-ready design layout.',
        },
        3: {
          title: 'Edit Freely & Export',
          description:
            'Adjust text, images, layout blocks, or styles. Export for social media, e-commerce platforms, or print.',
        },
        title: 'Simple Three Steps to Generate Designs',
      },
      audience: {
        title: 'Who Is Veeso AI For?',
        learn_more: 'Learn more',
        marketers: {
          title: 'For Marketers',
          description: 'Create stunning marketing content in minutes. No design skills needed.',
        },
        hr: {
          title: 'For HR',
          description:
            'Design engaging HR content, recruitment materials, and internal communications.',
        },
        founders: {
          title: 'For Founders',
          description:
            'Build your brand without a design team. Create professional content for your startup.',
        },
        creators: {
          title: 'For Creators',
          description:
            'Create content that stands out. YouTube thumbnails, Instagram posts, and more.',
        },
        startups: {
          title: 'For Startups',
          description:
            'Scale your design without scaling your team. Create professional materials at startup speed.',
        },
      },
      faq: {
        title: 'FAQ',
        items: [
          {
            question: 'What is Veeso AI?',
            answerParagraph1:
              'For SMB owners, marketers, operations, founders with limited design resources and tight deadlines, producing professional visuals is slow and expensive.',
            answerParagraph2:
              'Veeso is a content-first design tool that turns copywriting into clear, polished visuals in one click, one minute, no design skills required.',
            answerParagraph3:
              'Just paste your content or text, and instantly generate beautiful designs for',
            products: [
              'Social Media Post',
              'Poster',
              'Presentation',
              'Carousel',
              'Multi-Page Brochure',
              'Long-Form Content',
              'Restaurant Menu',
              'Invitation Card',
              'Pull Up Banner',
              'Flyer',
              'Album Cover',
            ],
          },
          {
            question: 'Is Veeso free to use?',
            answer:
              'Yes. Veeso offers free access to its AI design tools so you can generate and edit layouts without upfront cost. You can start creating instantly and explore different design generators in one place.',
          },
          {
            question: 'What makes Veeso different from other AI design tools?',
            answerParagraph1:
              'Most AI design tools generate flat images that are difficult to modify.',
            answerParagraph2:
              "Veeso generates structured layouts with editable text, sections, and visual hierarchy. You're not stuck with a static result — you can refine, adjust, and export a usable design file.",
            answerParagraph3: "It's built for real publishing, not just visual experiments.",
          },
          {
            question: 'Can I edit the designs generated by Veeso?',
            answerParagraph1: 'Yes. Every design generated by Veeso is fully editable. You can:',
            answerParagraph2: 'This gives you full control after generation.',
            listItems: [
              'Modify text content',
              'Rearrange layout blocks',
              'Replace images',
              'Adjust spacing and structure',
            ],
          },
          {
            question: 'Do I need to write prompts?',
            answerParagraph1: 'No. Veeso is built around content input, not prompt engineering.',
            answerParagraph2:
              'Simply paste your caption, product description, or event details. The AI automatically organizes it into a structured layout. No complex prompts required.',
          },
          {
            question: 'Is Veeso better than using templates?',
            answerParagraph1:
              'Templates are fixed layouts that require manual editing and adaptation.',
            answerParagraph2:
              'Veeso dynamically generates layouts based on your specific content. The structure adapts to your text, making the process faster and more flexible than starting from a static template.',
          },
          {
            question: 'Is Veeso a Canva alternative?',
            answerParagraph1:
              'Yes, but Veeso is not just a template-based editor. It focuses on AI-generated structured layouts that turn content directly into editable design files.',
            answerParagraph2:
              'It can complement traditional design tools by removing the need to start from scratch and speeding up the production process.',
          },
          {
            question: 'Is Veeso suitable for businesses?',
            answer:
              'Yes. Veeso is built for creators, marketers, e-commerce sellers, and small businesses who need production-ready visual content quickly.',
          },
        ],
      },
    },
  },
  articleDetail: {
    breadcrumb: {
      home: 'Home',
    },
    toc: {
      title: 'Table of Contents',
    },
    meta: {
      min_read: '{{count}} min read',
      last_updated: 'Last Updated:',
      author: 'Veeso Team',
    },
    faq: {
      title: 'FAQ',
      subtitle: 'Everything that you should know about design thinking',
    },
    share: {
      twitter: 'Share on X',
      linkedin: 'Share on LinkedIn',
      facebook: 'Share on Facebook',
      discord: 'Join Discord',
      aria_twitter: 'Share on Twitter',
      aria_linkedin: 'Share on LinkedIn',
      aria_facebook: 'Share on Facebook',
      aria_discord: 'Join Discord',
    },
    recommended: {
      title: 'Recommend for you',
      see_all: 'See all',
    },
    cta: {
      title_line1: 'Start Designing with',
      title_line2: 'Veeso AI Now.',
      signup: 'Get started for free',
    },
    seo_description_fallback: 'Read more on Veeso Blog',
  },
  blog: {
    index: {
      hero: {
        title: 'Learn & Blog',
        subtitle: 'Discover insights, tutorials, and best practices.',
      },
      seo: {
        description:
          'Discover insights, tutorials, and best practices for AI-powered design. Learn how to create stunning visuals with Veeso AI.',
        page_title: '{{title}} - Page {{page}} | Veeso',
      },
      faq: {
        title: 'FAQ',
      },
      pagination: {
        prev: '← Previous',
        next: 'Next →',
        prev_aria: 'Go to previous page',
        next_aria: 'Go to next page',
      },
      author_alt_fallback: 'Author',
      empty_state: 'No blog posts available yet. Check back soon!',
      min_read: '{{count}} min read',
      showing_posts: 'Showing {{start}}-{{end}} of {{total}} posts',
    },
    detail: {
      breadcrumb: {
        blog: 'Blog',
      },
    },
  },
  spotlight: {
    index: {
      hero: {
        subtitle_fallback:
          'AI launches, comparisons, and practical guides—while they still matter.',
      },
      min_read: '{{count}} min read',
      showing_posts: 'Showing {{start}}-{{end}} of {{total}} posts',
      author_alt_fallback: 'Author',
      image_alt_fallback: 'Spotlight post image',
      page_aria: 'Go to page {{page}}',
      seo: {
        page_title: '{{title}} - Page {{page}} | Veeso',
        description_fallback:
          'Timely takes on AI product launches, model comparisons, and practical guides—written for teams who ship visuals, not just screenshots.',
      },
      faq: {
        title_fallback: 'FAQ',
      },
      pagination: {
        prev: '← Previous',
        next: 'Next →',
        prev_aria: 'Go to previous page',
        next_aria: 'Go to next page',
      },
    },
    detail: {
      breadcrumb: {
        spotlight: 'Spotlight',
      },
      seo_description_fallback: 'Read more on Veeso Spotlight',
      image_alt_fallback: 'Article image',
      video_title_fallback: 'YouTube video',
    },
  },
  aiToolsDetail: {
    breadcrumb: {
      tools: 'AI Design Tools',
    },
    fallback: {
      title: 'AI Design Tool',
    },
    generation_methods: {
      title_prefix: 'Three Ways to Generate',
      product_type_fallback: 'Facebook Post',
      section_product_fallback: 'Amazon A+ Content',
    },
    choose_reasons: {
      cta: 'Try It Free',
    },
    use_cases: {
      title_fallback: 'Veeso AI Helps Create High-Converting Content Structures',
    },
    testimonials: {
      title_fallback: 'Why {{audienceType}} Choose Veeso AI',
      audience_fallback: 'Amazon Sellers',
    },
    how_to: {
      title_fallback: 'How to Create High-Converting {{productType}}',
      product_type_fallback: 'Amazon A+ Content',
    },
    faq: {
      title: 'FAQ',
    },
    cta: {
      image_alt: 'Create Editable Design Files, Not Just Images',
    },
    hero: {
      product_type_fallback: 'Amazon product',
      design: 'Design',
      designing: 'Designing...',
    },
    loading: 'Loading tool...',
    explore_more: 'Explore More AI Graphic Design Use Cases',
  },
  solutions: {
    slug: {
      'for-marketers': {
        title: 'Veeso for Marketers',
        subtitle: 'Create stunning marketing content in minutes',
        description: 'Turn your marketing ideas into beautiful visuals. No design skills needed.',
        heroTitle: 'Ship campaigns faster, boost conversion rates',
        heroSubtitle:
          'Transform your marketing briefs into production-ready visuals in minutes. Create social ads, email graphics, landing pages, and presentations that convert—without waiting for designers or compromising on brand consistency.',
        ctaText: 'Get started for free',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso for Marketers - Create Marketing Content Fast \\',
          description:
            'Create stunning marketing visuals in minutes with Veeso AI. No design skills needed. Perfect for marketing teams.',
        },
        features: [
          {
            title: 'Campaign-ready visuals',
            description:
              'Generate ad creatives, social media posts, email headers, and landing page graphics that align with your campaign goals. Every design is optimized for engagement and conversion.',
          },
          {
            title: 'Brand consistency at scale',
            description:
              'Maintain your brand guidelines across all marketing materials automatically. Consistent colors, fonts, and visual style ensure professional brand presence everywhere.',
          },
          {
            title: 'Multi-format output',
            description:
              'Create designs for all platforms simultaneously—Instagram stories, LinkedIn posts, email headers, presentation slides. One content input, multiple format outputs ready to publish.',
          },
          {
            title: 'A/B testing made easy',
            description:
              'Generate multiple design variations quickly to test what resonates with your audience. Iterate fast, optimize conversion rates, and scale winning creatives.',
          },
        ],
        faqItems: [
          {
            question: 'Can Veeso help me create A/B test variations for my campaigns?',
            answer:
              'Yes! Veeso makes it easy to generate multiple design variations from the same content. Simply modify your prompt or adjust the design settings to create different visual styles, layouts, or color schemes. This allows you to quickly test what resonates best with your audience and optimize conversion rates.',
          },
          {
            question: 'How does Veeso ensure brand consistency across all my marketing materials?',
            answer:
              'Veeso supports brand kits where you can set your brand colors, fonts, and logo. Once configured, all generated designs automatically apply your brand guidelines. This ensures consistent visual identity across social media posts, email graphics, presentations, and other marketing materials without manual oversight.',
          },
          {
            question: 'Can I create designs for multiple social media platforms at once?',
            answer:
              'Yes! Veeso can generate designs optimized for different platforms from the same content. Create Instagram posts, LinkedIn graphics, Twitter headers, and email headers simultaneously. Each output is formatted for its specific platform requirements, saving you time on manual resizing and reformatting.',
          },
          {
            question: 'How fast can I go from campaign brief to published content?',
            answer:
              'With Veeso, you can transform a marketing brief into production-ready visuals in minutes. Simply paste your campaign copy, select your desired formats, and Veeso generates polished designs. After quick edits and approvals, you can export and publish immediately—no waiting for designers or lengthy revision cycles.',
          },
          {
            question: 'Does Veeso support creating presentation slides for marketing decks?',
            answer:
              'Absolutely! Veeso excels at creating presentation slides from your content. Whether you need pitch decks, campaign proposals, or quarterly reports, Veeso automatically structures your content into professional slides with proper hierarchy, visuals, and formatting. Export directly to PowerPoint or PDF format.',
          },
          {
            question: 'Can I use Veeso to create email marketing graphics?',
            answer:
              'Yes, Veeso is perfect for email marketing. Create email headers, banner graphics, and inline visuals that are optimized for email clients. Designs are automatically formatted to work well across different email platforms and devices, ensuring your campaigns look professional everywhere.',
          },
          {
            question: 'How does Veeso help with landing page design?',
            answer:
              'Veeso can transform your landing page copy into complete visual layouts. Simply provide your headline, value propositions, features, and CTA text, and Veeso creates a structured, conversion-optimized design. You can then export the design or use it as a reference for your web development team.',
          },
          {
            question: 'Can I edit designs after they are generated to match my exact needs?',
            answer:
              'Yes! Every design generated by Veeso is fully editable. You can adjust text, change colors, resize elements, replace images, and modify layouts directly in the editor. This gives you complete control to fine-tune designs until they perfectly match your campaign requirements.',
          },
          {
            question: 'What file formats can I export marketing designs in?',
            answer:
              'Veeso supports multiple export formats including PNG, JPG, PDF, PPT, and HTML. Free plan users can export standard formats with watermark, while paid plans offer HD exports without watermarks. This flexibility ensures your marketing materials are ready for any platform or use case.',
          },
          {
            question: 'How does Veeso compare to hiring a designer for marketing campaigns?',
            answer:
              "Veeso offers speed and cost-effectiveness that traditional design workflows can't match. While designers take hours or days and require multiple revision cycles, Veeso generates professional designs in minutes. You maintain full creative control, can iterate instantly, and scale your visual content production without scaling your design budget. Perfect for marketing teams with tight deadlines and limited design resources.",
          },
        ],
      },
      'for-human-resource': {
        title: 'Veeso for Human Resources',
        subtitle: 'Design engaging HR content effortlessly',
        description:
          'Create recruitment materials, internal communications, and employee engagement visuals with ease.',
        heroTitle: 'Attract talent faster, boost employee engagement',
        heroSubtitle:
          'Create compelling job postings that stand out, professional internal communications that get read, and celebration graphics that boost morale—all without design skills or external agencies.',
        ctaText: 'Get started for free',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso for Human Resources - HR Design Made Easy \\',
          description:
            'Create engaging HR content, recruitment materials, and internal communications with Veeso AI.',
        },
        features: [
          {
            title: 'Recruitment that converts',
            description:
              "Design job postings and recruitment banners that catch candidates' attention. Professional visuals help your openings stand out in crowded job boards and social media feeds, attracting higher-quality applicants.",
          },
          {
            title: 'Internal communications that engage',
            description:
              'Transform company announcements, policy updates, and newsletters into visually engaging content. Well-designed internal communications improve readership and ensure important information reaches your team.',
          },
          {
            title: 'Employee recognition made special',
            description:
              'Create celebration graphics, milestone announcements, and recognition posts that make employees feel valued. Professional visuals amplify the impact of your recognition programs.',
          },
          {
            title: 'Onboarding materials that impress',
            description:
              'Design welcome packages, training materials, and orientation graphics that make new hires feel excited about joining. Professional onboarding visuals set the right tone from day one.',
          },
        ],
        faqItems: [
          {
            question: 'Can Veeso help me create job postings that attract better candidates?',
            answer:
              'Absolutely! Veeso transforms your job descriptions into visually compelling recruitment graphics. Well-designed job postings stand out on LinkedIn, job boards, and social media, attracting more qualified candidates. You can create multiple variations to test which designs perform best for different roles.',
          },
          {
            question: 'How can I use Veeso for employee recognition and celebrations?',
            answer:
              "Veeso is perfect for creating recognition graphics, anniversary announcements, promotion celebrations, and team achievement posts. Simply provide the employee's name, achievement details, and any specific messaging, and Veeso generates professional graphics that make recognition feel special and shareable.",
          },
          {
            question: 'Can I create internal newsletters and company updates with Veeso?',
            answer:
              'Yes! Veeso excels at transforming internal communications into engaging visual content. Create newsletters, policy announcements, company updates, and team communications that employees actually want to read. Visual hierarchy and professional design improve information retention and engagement.',
          },
          {
            question: 'How does Veeso help with onboarding materials?',
            answer:
              'Veeso can create welcome packages, orientation slides, training materials, and onboarding graphics that make new hires feel welcomed and informed. Professional visuals set a positive first impression and help new employees understand company culture and processes more effectively.',
          },
          {
            question: 'Can I maintain company branding across all HR materials?',
            answer:
              "Yes! Veeso's brand kit feature ensures all your HR materials maintain consistent visual identity. Set your company colors, fonts, and logo once, and all generated designs automatically follow your brand guidelines. This creates a cohesive, professional look across recruitment, internal communications, and employee engagement materials.",
          },
          {
            question: 'How fast can I create recruitment graphics for urgent job openings?',
            answer:
              'With Veeso, you can go from job description to published recruitment graphics in minutes. Simply paste your job details, select your preferred style, and Veeso generates multiple format options ready for LinkedIn, job boards, and social media. No waiting for designers or agencies.',
          },
          {
            question: 'Can I create materials for employee events and team building?',
            answer:
              'Absolutely! Veeso helps you create event invitations, team building announcements, workshop graphics, and celebration posts. Professional visuals increase event attendance and make team activities feel more engaging and organized.',
          },
          {
            question: 'Does Veeso support creating presentation slides for HR meetings?',
            answer:
              "Yes! Veeso can transform your HR meeting content into professional presentation slides. Whether it's quarterly reviews, policy updates, or training sessions, Veeso structures your content into clear, visually appealing slides that keep your audience engaged.",
          },
          {
            question: 'How can Veeso help with diversity and inclusion communications?',
            answer:
              'Veeso helps you create professional, inclusive visuals for D&I initiatives, awareness campaigns, and celebration months. Well-designed materials ensure your diversity and inclusion messages are communicated effectively and respectfully across all channels.',
          },
          {
            question: 'Can I create materials for remote or hybrid team communications?',
            answer:
              'Yes! Veeso is perfect for creating visuals that work well in digital communication channels. Design graphics optimized for Slack announcements, email updates, virtual meeting backgrounds, and remote team engagement that maintain connection and culture across distances.',
          },
        ],
      },
      'for-founders': {
        title: 'Veeso for Founders',
        subtitle: 'Build your brand without a design team',
        description:
          'Turn your vision into reality. Create professional content for your startup without hiring designers.',
        heroTitle: 'Launch faster, raise more, build your brand',
        heroSubtitle:
          'Create investor-ready pitch decks, professional social media content, and consistent brand visuals—all without hiring designers or breaking your budget. Focus on building your product while Veeso handles your visual identity.',
        ctaText: 'Start Building',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso for Founders - Build Your Startup Brand \\',
          description:
            'Create professional content for your startup without a design team. Build your brand, pitch decks, and social media presence.',
        },
        features: [
          {
            title: 'Investor-ready pitch decks',
            description:
              'Transform your startup story into compelling pitch deck slides that impress investors. Create data visualizations, product showcases, and market analysis graphics that communicate your vision clearly and professionally.',
          },
          {
            title: 'Brand identity from day one',
            description:
              'Establish a consistent visual identity across all touchpoints—website, social media, presentations, and marketing materials. Build brand recognition without the cost of hiring a design agency.',
          },
          {
            title: 'Product launch materials',
            description:
              'Create launch announcements, product screenshots, feature highlights, and demo visuals that showcase your product professionally. Make your launch memorable and shareable.',
          },
          {
            title: 'Fundraising visuals',
            description:
              'Design investor updates, milestone announcements, and growth graphics that keep stakeholders engaged. Professional visuals build credibility and help communicate your progress effectively.',
          },
        ],
        faqItems: [
          {
            question: 'Can Veeso help me create pitch decks that impress investors?',
            answer:
              'Yes! Veeso excels at creating professional pitch deck slides from your content. Transform your startup story, market analysis, product features, and financial projections into visually compelling slides. Veeso automatically structures your content with proper hierarchy, charts, and graphics that make your pitch more engaging and memorable.',
          },
          {
            question: 'How can I build a consistent brand identity without a designer?',
            answer:
              "Veeso's brand kit feature lets you set your brand colors, fonts, and visual style once. All designs automatically follow these guidelines, ensuring consistent brand identity across social media, presentations, marketing materials, and more. You can establish a professional brand presence from day one without hiring a design team.",
          },
          {
            question: 'Can I create product launch materials with Veeso?',
            answer:
              'Absolutely! Veeso helps you create launch announcements, product screenshots, feature highlight graphics, demo visuals, and launch campaign materials. Professional visuals make your product launch more impactful and shareable, helping you reach more potential customers.',
          },
          {
            question: 'How does Veeso help with investor updates and fundraising communications?',
            answer:
              'Veeso transforms your progress updates, metrics, and milestones into professional visual reports. Create investor update slides, growth charts, milestone graphics, and fundraising materials that clearly communicate your progress and build investor confidence.',
          },
          {
            question: "Can I create social media content that builds my startup's presence?",
            answer:
              'Yes! Veeso helps you create consistent, professional social media content across all platforms. Design posts, stories, banners, and headers that build your brand presence. Regular, well-designed content helps establish credibility and attracts customers, partners, and talent.',
          },
          {
            question: 'How fast can I go from idea to published content?',
            answer:
              'With Veeso, you can transform your ideas into published content in minutes. No waiting for designers, no back-and-forth revisions, no agency timelines. This speed is crucial for startups where timing and agility matter most.',
          },
          {
            question: 'Can I create materials for hiring and recruitment?',
            answer:
              'Yes! Veeso helps you create job postings, recruitment graphics, and employer branding materials that attract top talent. Professional visuals help your startup stand out in competitive hiring markets and communicate your company culture effectively.',
          },
          {
            question: 'How does Veeso compare to hiring a freelance designer?',
            answer:
              'Veeso offers significant cost savings and speed advantages. While freelance designers charge per project and take days or weeks, Veeso provides unlimited designs for a monthly subscription. You maintain full control, can iterate instantly, and scale your visual content production as your startup grows—all without increasing design costs.',
          },
          {
            question: 'Can I create materials for partnerships and business development?',
            answer:
              'Absolutely! Veeso helps you create partnership proposals, case studies, partnership announcements, and business development materials. Professional visuals make your partnership opportunities more compelling and help you close deals faster.',
          },
          {
            question: 'How can Veeso help with customer-facing materials?',
            answer:
              'Veeso helps you create customer onboarding materials, product documentation, feature guides, and customer communication graphics. Professional visuals improve customer understanding, reduce support burden, and enhance the overall customer experience.',
          },
        ],
      },
      'for-creators': {
        title: 'Veeso for Creators',
        subtitle: 'Create content that stands out',
        description:
          'Design stunning visuals for your content. YouTube thumbnails, Instagram posts, TikTok covers, and more.',
        heroTitle: 'Boost clicks, increase engagement, grow faster',
        heroSubtitle:
          'Create thumbnails that get clicks, social posts that drive engagement, and visuals that build your brand. Professional design helps you stand out in crowded feeds and grow your audience faster.',
        ctaText: 'Start Creating',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso for Creators - Create Content That Stands Out \\',
          description:
            'Design stunning visuals for YouTube, Instagram, TikTok, and more. Create content that grows your audience.',
        },
        features: [
          {
            title: 'Thumbnails that convert',
            description:
              'Design YouTube thumbnails that stop the scroll and drive clicks. Test multiple variations quickly to find what resonates with your audience. Higher click-through rates mean more views and faster channel growth.',
          },
          {
            title: 'Consistent brand identity',
            description:
              'Build a recognizable visual style across all your content. Consistent colors, fonts, and design elements help your audience instantly recognize your content, building brand loyalty and recall.',
          },
          {
            title: 'Multi-platform content',
            description:
              'Create optimized visuals for every platform—Instagram posts, TikTok covers, YouTube thumbnails, Twitter headers. One content idea, multiple platform-ready designs that maximize your reach.',
          },
          {
            title: 'Engagement-driving visuals',
            description:
              'Design visuals that encourage likes, shares, and comments. Well-crafted graphics with clear messaging and compelling visuals increase engagement rates and help your content perform better algorithmically.',
          },
        ],
        faqItems: [
          {
            question: 'Can Veeso help me create YouTube thumbnails that get more clicks?',
            answer:
              'Absolutely! Veeso helps you create eye-catching YouTube thumbnails optimized for click-through rates. You can quickly generate multiple variations to test what works best for your audience. Well-designed thumbnails with clear text, compelling visuals, and proper contrast significantly improve click-through rates, leading to more views and faster channel growth.',
          },
          {
            question: 'How can I maintain a consistent visual style across all my content?',
            answer:
              "Veeso's brand kit feature lets you set your signature colors, fonts, and visual style. Once configured, all your designs automatically follow these guidelines, ensuring consistent brand identity across YouTube thumbnails, Instagram posts, TikTok covers, and other content. This consistency helps your audience recognize your content instantly and builds brand loyalty.",
          },
          {
            question: 'Can I create content for multiple platforms from the same idea?',
            answer:
              "Yes! Veeso allows you to create platform-optimized designs from the same content. Transform one video idea into a YouTube thumbnail, Instagram post, TikTok cover, and Twitter header—all formatted correctly for each platform. This maximizes your content's reach without creating everything from scratch.",
          },
          {
            question: 'How does Veeso help improve my engagement rates?',
            answer:
              'Veeso helps you create visuals with clear messaging, compelling compositions, and proper visual hierarchy that encourage likes, comments, and shares. Well-designed graphics perform better algorithmically, leading to more organic reach and faster audience growth.',
          },
          {
            question: 'Can I create Instagram carousel posts with Veeso?',
            answer:
              'Yes! Veeso excels at creating multi-slide Instagram carousel posts. Simply provide your content for each slide, and Veeso generates a cohesive carousel design with consistent styling. Carousel posts typically get higher engagement rates than single images, helping you grow faster.',
          },
          {
            question: 'How fast can I create content for my posting schedule?',
            answer:
              'With Veeso, you can create multiple pieces of content in minutes. This speed is crucial for creators who need to maintain consistent posting schedules. Batch-create thumbnails, social posts, and other visuals ahead of time, ensuring you never miss a posting opportunity.',
          },
          {
            question: 'Can I create TikTok covers and video thumbnails?',
            answer:
              'Absolutely! Veeso helps you create TikTok covers, video thumbnails, and story graphics that stand out in crowded feeds. Professional visuals help your videos get more views and improve your overall channel performance.',
          },
          {
            question: 'How does Veeso help with A/B testing my content?',
            answer:
              'Veeso makes it easy to create multiple design variations quickly. Test different thumbnail styles, color schemes, text treatments, and layouts to see what resonates best with your audience. This data-driven approach helps you optimize your content strategy and improve performance over time.',
          },
          {
            question: 'Can I create branded templates for my regular content?',
            answer:
              'Yes! Once you establish your brand style in Veeso, you can quickly create new content that follows the same visual language. This consistency saves time while ensuring all your content maintains your signature look and feel.',
          },
          {
            question: 'How can Veeso help me grow my audience faster?',
            answer:
              'Professional visuals help your content stand out in crowded feeds, leading to higher click-through rates, better engagement, and improved algorithmic performance. When your content looks professional and consistent, audiences are more likely to follow, share, and remember your brand—all of which accelerate growth.',
          },
        ],
      },
      'for-startups': {
        title: 'Veeso for Startups',
        subtitle: 'Scale your design without scaling your team',
        description:
          'Create professional marketing materials, product visuals, and brand assets at startup speed.',
        heroTitle: 'Launch faster, scale smarter, grow without limits',
        heroSubtitle:
          'Create unlimited professional designs without hiring designers. Scale your visual content production as fast as you scale your product—all while maintaining brand consistency and professional quality.',
        ctaText: 'Get Started',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso for Startups - Scale Your Design \\',
          description:
            'Create professional marketing materials and product visuals at startup speed. Scale your design without scaling your team.',
        },
        features: [
          {
            title: 'Launch-ready marketing materials',
            description:
              'Create landing pages, ad creatives, email campaigns, and social media content that drive conversions. Professional visuals help you compete with established brands from day one.',
          },
          {
            title: 'Product visuals that sell',
            description:
              'Design product screenshots, feature highlights, demo graphics, and showcase visuals that clearly communicate your value proposition. Great visuals help potential customers understand and want your product.',
          },
          {
            title: 'Consistent brand at scale',
            description:
              'Maintain professional brand identity across all touchpoints as you grow. Brand kits ensure every design follows your guidelines automatically, building trust and recognition without manual oversight.',
          },
          {
            title: 'Cost-effective design operations',
            description:
              'Eliminate the need to hire designers or work with agencies. Create unlimited designs for a fraction of the cost, allowing you to invest more in product development and growth.',
          },
        ],
        faqItems: [
          {
            question: 'How does Veeso help startups compete with established brands visually?',
            answer:
              'Veeso enables startups to create professional, polished visuals that match or exceed the quality of established brands. With consistent branding, high-quality designs, and proper visual hierarchy, your startup can build credibility and trust from day one—without the cost of hiring a design agency.',
          },
          {
            question: 'Can I create all the marketing materials I need for a product launch?',
            answer:
              'Yes! Veeso helps you create everything needed for a launch: landing page graphics, ad creatives, email campaign visuals, social media content, press release graphics, and product showcase materials. All designs maintain brand consistency and professional quality, ensuring your launch looks polished and credible.',
          },
          {
            question: 'How does Veeso help with scaling design operations as we grow?',
            answer:
              'Veeso scales with your startup. Create unlimited designs without hiring additional designers or increasing costs. As your product grows and you need more marketing materials, product visuals, and brand assets, Veeso enables you to produce them instantly without scaling your design team or budget.',
          },
          {
            question:
              'Can I create product screenshots and feature graphics that showcase my product?',
            answer:
              'Absolutely! Veeso helps you create professional product screenshots, feature highlight graphics, demo visuals, and comparison charts. Well-designed product visuals help potential customers understand your value proposition quickly and make purchasing decisions faster.',
          },
          {
            question: 'How does Veeso compare to hiring freelance designers?',
            answer:
              'Veeso offers significant advantages: unlimited designs for a fixed monthly cost vs. per-project fees, instant turnaround vs. days or weeks of wait time, full creative control vs. back-and-forth revisions, and consistent brand application vs. manual oversight. For startups, this means faster iteration, lower costs, and better scalability.',
          },
          {
            question: 'Can I maintain brand consistency across all materials as we scale?',
            answer:
              "Yes! Veeso's brand kit feature ensures all designs automatically follow your brand guidelines. As you create more materials—marketing campaigns, product visuals, presentations, social content—everything maintains consistent colors, fonts, and visual style without manual review.",
          },
          {
            question: 'How fast can I create materials for time-sensitive campaigns?',
            answer:
              'With Veeso, you can go from campaign idea to published visuals in minutes. This speed is crucial for startups where market opportunities move fast. No waiting for designers, no agency timelines—just instant, professional results.',
          },
          {
            question: 'Can I create investor materials and fundraising visuals?',
            answer:
              'Yes! Veeso helps you create pitch decks, investor updates, growth charts, milestone graphics, and fundraising materials. Professional visuals help communicate your progress clearly and build investor confidence, which is essential for successful fundraising.',
          },
          {
            question: 'How does Veeso help with customer acquisition materials?',
            answer:
              'Veeso enables you to create conversion-optimized landing pages, ad creatives, email campaigns, and social media content that drive customer acquisition. Professional visuals improve click-through rates, engagement, and conversion rates—directly impacting your growth metrics.',
          },
          {
            question: 'Can I create materials for partnerships and business development?',
            answer:
              "Absolutely! Veeso helps you create partnership proposals, case studies, integration graphics, and business development materials. Professional visuals make your partnership opportunities more compelling and help you close deals faster, accelerating your startup's growth.",
          },
        ],
      },
      default: {
        title: 'Veeso Solutions',
        subtitle: 'Discover how Veeso can help you',
        description: 'Find the perfect solution for your needs.',
        heroTitle: 'Solutions for every team',
        heroSubtitle: 'Discover how Veeso can help you create stunning visuals.',
        ctaText: 'Get Started',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso Solutions',
          description: 'Discover Veeso solutions for your team.',
        },
        features: [],
        faqItems: [],
      },
    },
  },
};
